import React, { useState, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import Titlebanner from "../../../globel_cmponents/title_banner";
import { Button, Card, CardBody, Col, Row, Label } from "reactstrap";
import RenderField from "../../formcomponent/formfields/RenderField";
import EditorField from "../../formcomponent/editorfield/EditorField";
import axios from "axios";
import Swal from "sweetalert2";
import requests from "../../../utils/Requests";
import { useHistory, useParams } from "react-router-dom";
import DropZoneSingleRender from "../../formcomponent/formfields/dropzonSingle/DropZoneSingleRender";
const CreateMealType = (props) => {
  const { handleSubmit } = props;
  const history = useHistory();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [mealtypeFullData, setMealtypeFullData] = useState("");
  const [codeFormet, setCodeFormet] = useState([
    { value: "", name: "" },
    { value: 1, name: "QRCode" },
    { value: 2, name: "BarCode" },
  ]);

  const activeStatus = [
    { value: "", name: "" },
    { value: true, name: "Active" },
    { value: false, name: "InActive" },
  ];
  const [hotemIdList, stHotelIdList] = useState([]);
  useEffect(() => {
    getHotelList();
  }, []);
  const getHotelList = async () => {
    await axios
      .post(requests.getMealHotelList, { hotelId: 1 })
      .then((res) => {
        console.log(res.data);
        const processData = res.data.map((item) => ({
          value: item.mealHotelId,
          name: item.hotelName,
        }));
        stHotelIdList(processData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (id != "null") {
      setIsLoading(true);
      getMealTypeDetails();
    }
  }, [id]);

  const getMealTypeDetails = async () => {
    await axios
      .post(requests.getMealType, { mealTypeId: id })
      .then((res) => {
        console.log(res.data);
        setMealtypeFullData(res.data);
        props.initialize({
          ...res.data,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const postToApi = async (values) => {
    console.log(values);
    await axios
      .post(requests.createMealType, values)
      .then((res) => {
        console.log(res.data);
        Swal.fire("success", "Meals Type Added", "success");
        history.push("/Meals/MealsHotellist/hotel-mealtype-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Titlebanner title="Create Meals Type" />

      <Card>
        {isLoading === false ? (
          <CardBody>
            <Row>
              <Col>
                <Field
                  name="mealHotelId"
                  type="select"
                  label="Hotel Name"
                  customfeild={hotemIdList}
                  component={RenderField.renderOptionField}
                />
              </Col>
              <Col>
                <Field
                  name="mealName"
                  label="Meal Name"
                  component={RenderField.RenderTextField}
                />
              </Col>

              <Col>
                <Field
                  name="actualPrice"
                  label="Actual Price"
                  component={RenderField.RenderTextField}
                />
              </Col>
              <Col>
                <Field
                  name="active"
                  type="select"
                  customfeild={activeStatus}
                  component={RenderField.renderOptionField}
                  label="Active Status"
                />
              </Col>
              <Col>
                <Field
                  name="offerPrice"
                  label="Offer Price"
                  component={RenderField.RenderTextField}
                />
              </Col>
              <Col>
                <Field
                  name="qrOrBarCode"
                  type="select"
                  label="Code Formet"
                  customfeild={codeFormet}
                  component={RenderField.renderOptionField}
                />
              </Col>
            </Row>

            <Row>
              <br />
              <Label> Description</Label>
              <Field
                key="field"
                name="description"
                id="inputEditorText"
                disabled={false}
                component={EditorField}
                placeholder="Type here"
              />

              <br />
              <Label> Terms And Conditions</Label>
              <Field
                key="field"
                name="termsAndConditions"
                id="inputEditorText"
                disabled={false}
                component={EditorField}
                placeholder="Type here"
              />
            </Row>
            <br />
            <br />
            <br />

            {mealtypeFullData != "" && (
              <img
                src={
                  "https://parmartours.com:8443/filestorage/parmartour/images/" +
                  mealtypeFullData.thumbNailImage
                }
                width="100px"
                height="100px"
                alt="placeholder grey 100px"
              />
            )}
            <Label> Thumbnail Image </Label>
            <Field
              // key="field"
              name="thumbNailImage"
              component={DropZoneSingleRender}
            />
            <br />
            <br />
            {mealtypeFullData != "" && (
              <img
                src={
                  "https://parmartours.com:8443/filestorage/parmartour/images/" +
                  mealtypeFullData.galleryImage
                }
                width="100px"
                height="100px"
                alt="placeholder grey 100px"
              />
            )}
            <Label> Gallery Image </Label>
            <Field
              // key="field"
              name="galleryImage"
              component={DropZoneSingleRender}
            />
            <br />
            <br />

            <div className="float-right">
              <Button
                color="primary"
                onClick={handleSubmit((values) =>
                  postToApi({
                    ...values,
                    pill: 1,
                  })
                )}
              >
                Create
              </Button>
            </div>
          </CardBody>
        ) : (
          ""
        )}
      </Card>
    </div>
  );
};

export default reduxForm({
  form: "CreateMealType",
})(CreateMealType);
